export * from './SegurosPromo.icon';
export * from './Help.icon';
export * from './Cart.icon';
export * from './User.icon';
export * from  './ChevronRight.icon';
export  * from './Google.icon';
export * from './Email.icon';
export * from './Close.icon';
export * from './Menu.icon';
export * from './UserAnimation.icon';


// WEBPACK FOOTER //
// ./src/assets/icons/index.jsx